import type { ManageProspectsState } from './types';

export const selectCurrentFilter = (state: { manageProspects: ManageProspectsState }) =>
  state.manageProspects.currentFilter;

export const selectCurrentSorting = (state: { manageProspects: ManageProspectsState }) =>
  state.manageProspects.currentSorting;

export const selectSearchText = (state: { manageProspects: ManageProspectsState }) => state.manageProspects.searchText;
